import { Form, Input, message, Modal } from "antd";
import { useForm } from "antd/es/form/Form";
import React, { useEffect } from "react";
import HTTPSCalls from "../Services/HTTPCalls";
import { IApiResponse } from "../Utilities/ApiUtility.axios";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../Store/store";
import { isDefaultPassword, setUserData } from "../Store/Slice/userSlice";

const ChangePasswordModal = ({ openModel, setOpenModel }: any) => {
  const [form] = useForm();
  const [confirmLoading, setConfirmLoading] = React.useState<boolean>(false);
  const [hasOpened, setHasOpened] = React.useState<boolean>(false);
  const handleCancel = () => {
    setOpenModel((pre: any) => !pre);
  };
  const user = useSelector((state: RootState) => state.user);
  const defaultPassword = useSelector(isDefaultPassword);
  useEffect(() => {
    if (defaultPassword && !hasOpened) {
      setOpenModel(true);
      setHasOpened(true);
    }
  }, [defaultPassword, hasOpened, setOpenModel]);

  const dispatch = useDispatch();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setConfirmLoading(true);

      const payload = {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      };

      const response: IApiResponse = await HTTPSCalls.POST(
        `${HTTPSCalls.ENDPOINTS.RESET_PASSWORD}/${user?.id}`,
        {},
        payload
      );

      if (response.status) {
        message.success("Password reset successfully.");
        form.resetFields();
        setOpenModel(false);
        dispatch(setUserData({ ...user, isDefaultPassword: false }));
      } else {
        message.error(response?.message || "Password reset failed.");
      }
    } catch (error) {
      // Validation errors or request failure
      message.error("An error occurred while resetting password.");
    } finally {
      setConfirmLoading(false);
    }
  };

  return (
    <>
      <Modal
        maskClosable={false}
        title="Change your password"
        open={openModel}
        onOk={form.submit}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        closable={!defaultPassword}
        // okButtonProps={{disabled:defaultPassword}}
        cancelButtonProps={{ disabled: defaultPassword }}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="currentPassword"
            label="Current Password"
            rules={[
              { required: true, message: "Please enter current password" },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="New Password"
            rules={[
              { required: true, message: "Please enter new password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm your password" },
              { min: 6, message: "Password must be at least 6 characters" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The two passwords do not match!")
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ChangePasswordModal;
